<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <!-- <h5 class="card-title font-weight-bold font-size-lg mb-4">Customer Service</h5> -->
            <form [formGroup]="customerForm">
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <div class="form-group">
                            <label for="station">Station *</label>
                            <ng-select id="station" [multiple]="false" required formControlName="station" [ngClass]="{'is-invalid': submitted && f.station.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <!-- <ng-option [value]="'ALL'">
                                    ALL
                                </ng-option> -->
                                <ng-option *ngFor="let station of allStations" [value]="station.StationCode">
                                    {{station?.STATIONID}} - {{station.AirportName}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.station">
                                <div class="error-message" *ngIf="f.station.hasError(validation.type) &&  ((f.station.dirty || f.station.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="an">Agency </label>
                            <ng-select id="agency" formControlName="agency_Name" placeholder="Select Agency Name" (change)="onAgencyChange($event)">
                                <ng-option *ngFor="let agency of agenciesByStations" [value]="agency.AGENCY_ID">
                                    {{agency.COMPANY_NAME}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div> 

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="cn">Customer Bill To(Company Name) *</label>
                            <input id="cn" class="form-control" formControlName="company_Name" placeholder="Company Name" type="text" [ngClass]="{'is-invalid': submitted && f.company_Name.errors}">
                            <div *ngFor="let validation of validation_messages.company_Name">
                                <div class="error-message" *ngIf="f.company_Name.hasError(validation.type) && ((f.company_Name.dirty  || f.company_Name.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="c_n">Customer Name *</label>
                            <input id="c_n" class="form-control" formControlName="contact_Name" placeholder="Customer Name" type="text" [ngClass]="{'is-invalid': submitted && f.contact_Name.errors}">
                            <div *ngFor="let validation of validation_messages.contact_Name">
                                <div class="error-message" *ngIf="f.contact_Name.hasError(validation.type) && ((f.contact_Name.dirty  || f.contact_Name.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div> 

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="ce">Email *</label>
                            <input id="ce" class="form-control" formControlName="contact_Email" placeholder="Contact Email" type="email" [ngClass]="{'is-invalid': submitted && f.contact_Email.errors}">
                            <div *ngFor="let validation of validation_messages.contact_Email">
                                <div class="error-message" *ngIf="f.contact_Email.hasError(validation.type) && ((f.contact_Email.dirty  || f.contact_Email.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">  
                        <div class="form-group">
                            <label for="cp">Phone No </label>
                            <input id="cp" class="form-control" formControlName="contact_Phone" placeholder="Phone No" type="text" [ngClass]="{'is-invalid': submitted && f.contact_Phone.errors}">
                            <div *ngFor="let validation of validation_messages.contact_Phone">
                                <div class="error-message" *ngIf="f.contact_Phone.hasError(validation.type) && ((f.contact_Phone.dirty  || f.contact_Phone.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>   
                    <!-- type="email" minlength="10" maxlength="20" -->

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="cf">Customer Fax </label>
                            <input id="cf" class="form-control" formControlName="contact_Fax" placeholder="Customer Fax" type="text" [ngClass]="{'is-invalid': submitted && f.contact_Fax.errors}">
                            <div *ngFor="let validation of validation_messages.contact_Fax">
                                <div class="error-message" *ngIf="f.contact_Fax.hasError(validation.type) && ((f.contact_Fax.dirty  || f.contact_Fax.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="row">    

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="cd">Customer Description </label>
                            <input id="cd" class="form-control" formControlName="customer_Description" placeholder="Customer Description" type="text" [ngClass]="{'is-invalid': submitted && f.customer_Description.errors}">
                            <div *ngFor="let validation of validation_messages.customer_Description">
                                <div class="error-message" *ngIf="f.customer_Description.hasError(validation.type) && ((f.customer_Description.dirty  || f.customer_Description.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="a_1">Address-1 </label>
                            <input id="a_1" class="form-control" formControlName="address_1" placeholder="Address-1" type="text" [ngClass]="{'is-invalid': submitted && f.address_1.errors}">
                            <div *ngFor="let validation of validation_messages.address_1">
                                <div class="error-message" *ngIf="f.address_1.hasError(validation.type) && ((f.address_1.dirty  || f.address_1.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="a_2">Address-2 </label>
                            <input id="a_2" class="form-control" formControlName="address_2" placeholder="Address-2" type="text" [ngClass]="{'is-invalid': submitted && f.address_2.errors}">
                            <div *ngFor="let validation of validation_messages.address_2">
                                <div class="error-message" *ngIf="f.address_2.hasError(validation.type) && ((f.address_2.dirty  || f.address_2.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>      

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="state">State </label>
                            <input id="state" class="form-control" formControlName="state" placeholder="State" type="text" [ngClass]="{'is-invalid': submitted && f.state.errors}">
                            <!-- <div *ngFor="let validation of validation_messages.state">
                                <div class="error-message" *ngIf="f.state.hasError(validation.type) && ((f.state.dirty  || f.state.touched))">
                                    {{validation.message }}
                                </div>
                            </div> -->
                        </div>
                    </div>  

                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="city">City </label>
                            <input id="city" class="form-control" formControlName="city" placeholder="City" type="text" [ngClass]="{'is-invalid': submitted && f.city.errors}">
                            <div *ngFor="let validation of validation_messages.city">
                                <div class="error-message" *ngIf="f.city.hasError(validation.type) && ((f.city.dirty  || f.city.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>          

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="zipcode">Zipcode </label>
                            <input id="zipcode" class="form-control" formControlName="zipcode" placeholder="Zipcode" type="text" maxlength="10" [ngClass]="{'is-invalid': submitted && f.zipcode.errors}">
                            <div *ngFor="let validation of validation_messages.zipcode">
                                <div class="error-message" *ngIf="f.zipcode.hasError(validation.type) && ((f.zipcode.dirty  || f.zipcode.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>    

                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="nt">Net Terms </label>
                            <input id="nt" class="form-control" formControlName="net_Terms" placeholder="Net Terms" type="number" [ngClass]="{'is-invalid': submitted && f.net_Terms.errors}">
                            <div *ngFor="let validation of validation_messages.net_Terms">
                                <div class="error-message" *ngIf="f.net_Terms.hasError(validation.type) && ((f.net_Terms.dirty  || f.net_Terms.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>   
                    
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="rn">Chase Profile ID <small> ( Generated by Chase  for Credit Card)</small></label>
                            <input id="rn" class="form-control" formControlName="prof_Cust_RefNum" placeholder="Chase Profile ID Number" type="text" [ngClass]="{'is-invalid': submitted && f.prof_Cust_RefNum.errors}">
                            <div *ngFor="let validation of validation_messages.prof_Cust_RefNum">
                                <div class="error-message" *ngIf="f.prof_Cust_RefNum.hasError(validation.type) && ((f.prof_Cust_RefNum.dirty  || f.prof_Cust_RefNum.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>     

                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="tt">Transaction Type *</label>
                            <ng-select id="tt" [multiple]="false" required formControlName="transaction_Type" [ngClass]="{'is-invalid': submitted && f.transaction_Type.errors}" placeholder="Select Transaction Type" (change)="onTransTypeChange()">
                                <ng-option *ngFor="let type of allTransactionTypes" [value]="type.name">
                                    {{type.name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.transaction_Type">
                                <div class="error-message" *ngIf="f.transaction_Type.hasError(validation.type) &&  ((f.transaction_Type.dirty || f.transaction_Type.touched))">
                                    {{validation.message }} 
                                </div>
                            </div>
                        </div>
                    </div>              
                    
                    <div class="col-lg-3 col-sm-6">
                        <div class="form-group">
                            <label for="cn">Country *</label>
                            <input id="cn" class="form-control" formControlName="country" placeholder="Country" type="text" [ngClass]="{'is-invalid': submitted && f.country.errors}">
                            <div *ngFor="let validation of validation_messages.country">
                                <div class="error-message" *ngIf="f.country.hasError(validation.type) && ((f.country.dirty  || f.country.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>  

                    <div class="col-lg-3 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="empid">Status * </label>
                            <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && f.active.errors}" placeholder="Select Status" >
                                <ng-option *ngFor="let status of statusTypes" [value]="status.active">
                                    {{status.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="row" >
                    <div class="col-md-6 col-lg-6 col-sm-6"   *ngIf="f.transaction_Type.value == 'Credit Card' && f.transaction_Type.value != 'Cheque'">
                        <div class="form-group" >
                            <label for="pm" class="font-weight-bold">Do you want to <span *ngIf="!isEditMode">add </span> <span *ngIf="isEditMode">update </span> credit card details ? </label>
                            <ng-select  id="active" required formControlName="ccConfirmation" [ngClass]="{'is-invalid': submitted && f.ccConfirmation.errors}" placeholder="Confirmation" (change)="onCardConfirmationChange()">
                                <ng-option *ngFor="let c of ccConfirmation" [value]="c.name">
                                    {{c.name}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.ccConfirmation">
                                <div class="error-message" *ngIf="f.ccConfirmation.hasError(validation.type) &&  ((f.ccConfirmation.dirty || f.ccConfirmation.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="f.ccConfirmation.value == 'Yes'">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="52">Credit Card Number * :</label>
                            <div class="input-group">
                                <span class="input-group-prepend">
                                    <span class="input-group-text">
                                        <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                    </span>
                                </span>
                                <!-- [textMask]="{mask: maskCreditCard}" -->
                                <input formControlName="creditCardNo"  autocomplete="cc-number" ccNumber 
                                    class="form-control" id="cc-number" name="cc-number" type="tel"
                                    [ngClass]="{'is-invalid': submitted && f.creditCardNo.errors}" />
                            </div>
                            <div *ngFor="let validation of validation_messages.creditCardNo">
                                <div class="error-message"
                                    *ngIf="f.creditCardNo.hasError(validation.type) && ((f.creditCardNo.dirty  || f.creditCardNo.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                            <div *ngIf="isCapitalOneValidate()"
                                 class="relative -top-5 text-xs"
                            >
                                Capital One card number detected.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="4">Expire Date * :</label>
                            <div class="input-group">
                                <span class="input-group-prepend">
                                    <span class="input-group-text">
                                        <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                                    </span>
                                </span>
                                <input formControlName="expireMonthYear" [textMask]="{mask: maskDate}" class="form-control"
                                    id="4" name="date-mask" type="text"
                                    [ngClass]="{'is-invalid': submitted && f.expireMonthYear.errors}" />
                            </div>
                            <div *ngFor="let validation of validation_messages.expireMonthYear">
                                <div class="error-message"
                                    *ngIf="f.expireMonthYear.hasError(validation.type) && ((f.expireMonthYear.dirty  || f.expireMonthYear.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 py-3">
                        <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                        <button id="saveCustomerBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddCustomer(customerForm.value)" *ngIf="!isEditMode">Add Customer</button>
                        <button id="updateCustomerBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateCustomer(customerForm.value)" *ngIf="isEditMode">Update Customer </button>
                        <!-- <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>